import React from 'react';

import { Badge } from '@column/ui';

import { getProgressFromTransferStatus, getTransferProgressIcon } from '../progress';
import { formatTransferStatusLabel, getStatusBadgeTone, getStatusIconClassName } from '../status';
import { TransferStatus, parseTransferStatus } from '../types';
import { getTransferBadgeClassName } from '../utils';
import { TransferEntryType } from '~/repositories';

interface TransferStatusBadgeProps {
  status: string | TransferStatus;
  type: TransferEntryType;
}

export const TransferStatusBadge: React.FC<TransferStatusBadgeProps> = ({ status: rawStatus, type }) => {
  const status = parseTransferStatus(rawStatus);
  const progress = getProgressFromTransferStatus(status);
  const tone = getStatusBadgeTone(progress, status);

  return (
    <Badge variant="ghost" className={getTransferBadgeClassName(tone)}>
      <span className={getStatusIconClassName(tone)}>{getTransferProgressIcon(progress)}</span>
      {formatTransferStatusLabel(status, type)}
    </Badge>
  );
};
